import "../../utils/polyfillTextTrackCue";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-ads';
import 'videojs-ima';
import { checkOperatingSystem } from "../../utils/utils";
import { ssaiAdParam } from '../../utils/utils';
import { capitalize } from '@mui/material';
export const VideoJS = (props) => {
  const [controlColor, setControlColor] = useState();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  // const pauseRef = React.useRef(null);
  const { options, onReady, pauseVideo, isTrailer, poster, is_live, isRadioLive, isPlaylist, kids, videoResolutionInfo, videoUrl } = props;

  const location = useLocation()
  let uid = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uid = user_id
  }
  const appInfo = {
    projectDetails: projectInfo
  }

  if (videojs.Vhs) {
    videojs.Vhs.xhr.beforeRequest = function (options) {
      if (options?.uri.includes(".m3u8?id=")) {
        options.headers = {
          pubid: projectInfo?.projectConfig?.pubid,
          channelid: projectInfo?.projectConfig?.channelid,
          uid: uid,
          "access-token": accessToken,
        };
      }
      return options;
    };
  } else {
    console.warn("VHS plugin is not available in this version of Video.js.");
  }

  React.useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;

      if (!videoElement) return;
      if (props?.liveData?.channel_id) {
        if (props?.liveData?.ssai_enabled) {
          ssaiAdParam(props?.liveData, appInfo).then((response) => {
            createSSAI(props?.liveData.ssai_link, videoElement, response, false)

          })
        } else {
          const player = playerRef.current = videojs(videoElement, { ...options, autoplay: !kids }, () => {
            applyCaptionFontSize(player);
            initButtons(player);
            onReady && onReady(player);
          });
          initButtons(player);
        }
      } else {
        const player = playerRef.current = videojs(videoElement, { ...options, autoplay: !kids }, () => {
          applyCaptionFontSize(player);
          initButtons(player);
          onReady && onReady(player);
        });
        initButtons(player);
      }

    } else {
      const player = playerRef.current;
      if (player && options?.sources) {
        try {
          player.src(options.sources);
        } catch (e) {
        }
      }
      initButtons(player);
    }
  }, [options, videoRef, videoResolutionInfo, videoUrl]);

  function initButtons(player) {
    if (!player || is_live) return;
    try {
      createRestartButton && createRestartButton(player);
      createQualityButton && createQualityButton(player, videoResolutionInfo, videoUrl);
    } catch (e) {
      console.warn('initButtons error', e);
    }
  }

  function applyCaptionFontSize(player) {
    if (!player?.el()) return;

    const trackDisplay = player.el().querySelector('.vjs-text-track-display');
    if (!trackDisplay) return;

    const updateCaptionFontSize = () => {
      const fontPercent = Number(player.textTrackSettings?.getValues()?.fontPercent) || 1;
      const defaultFontSize = window.innerWidth <= 768 ? 13 : 15;
      const fontSize = `${defaultFontSize * fontPercent}px`;

      trackDisplay.querySelectorAll('.vjs-text-track-cue').forEach((cue) => {
        if (cue.style.fontSize !== fontSize) {
          cue.style.fontSize = fontSize;
        }
      });
    };

    const observer = new MutationObserver(updateCaptionFontSize);
    observer.observe(trackDisplay, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    updateCaptionFontSize();
    player.one('dispose', () => observer.disconnect());
  }

  function createRestartButton(player) {
    if (!player || is_live) return;

    try {
      if (!videojs.getComponent('RestartButton')) {
        const Button = videojs.getComponent('Button');

        const RestartButton = videojs.extend(Button, {
          constructor: function (p, options) {
            Button.apply(this, arguments);
            this.controlText('Start Over');
          },
          handleClick: function () {
            const p = this.player();
            try {
              p.currentTime(0);
              p.play();
              try {
                this.el() && this.el().blur && this.el().blur();
              } catch (err) {
              }
            } catch (err) {
              console.warn('Restart button action error', err);
            }
          }
        });

        videojs.registerComponent('RestartButton', RestartButton);
      }

      const controlBar = player.getChild('controlBar') || player.controlBar;
      if (controlBar && !controlBar.getChild('RestartButton')) {
        let insertIndex = undefined;
        const fs = controlBar.getChild('fullscreenToggle') || controlBar.getChild('FullscreenToggle') || controlBar.getChild('fullScreenToggle');
        if (fs && typeof controlBar.children === 'function') {
          const children = controlBar.children();
          const idx = children.indexOf(fs);
          if (idx >= 0) insertIndex = idx;
        }
        if (insertIndex === undefined && typeof controlBar.children === 'function') {
          insertIndex = Math.max(0, controlBar.children().length - 1);
        }

        controlBar.addChild('RestartButton', {}, insertIndex);
        const btn = controlBar.getChild('RestartButton');
        if (btn && btn.el()) {
          btn.el().classList.add('vjs-restart-button', 'vjs-control');
          btn.el().setAttribute('aria-label', 'Start Over');
          try {
            btn.el().innerHTML = `
              <svg class="vjs-restart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                <path d="M12 5V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
              </svg>
              <span class="vjs-control-text">Start Over</span>
            `;
          } catch (e) {
          }
        }
      }

      const disableRestart = () => {
        const cb = player.getChild('controlBar') || player.controlBar;
        const btn = cb?.getChild('RestartButton');
        if (btn && btn.disable) btn.disable();
      };
      const enableRestart = () => {
        const cb = player.getChild('controlBar') || player.controlBar;
        const btn = cb?.getChild('RestartButton');
        if (btn && btn.enable) btn.enable();
      };

      player.on && player.on('adstart', disableRestart);
      player.on && player.on('adend', enableRestart);
      player.on && player.on('ads-ad-started', disableRestart);
      player.on && player.on('ads-ad-ended', enableRestart);
      player.on && player.on('ima3-started', disableRestart);
      player.on && player.on('ima3-complete', enableRestart);
      player.on && player.on('contentresume', enableRestart);

    } catch (e) {
      console.warn('createRestartButton error', e);
    }
  }

  function createQualityButton(player, currentResolutions, currentVideoUrl) {
    if (!player || is_live) return;

    const resolutions = (currentResolutions && Array.isArray(currentResolutions) && currentResolutions.length > 0)
      ? currentResolutions
      : ((props && props.videoResolutionInfo && Array.isArray(props.videoResolutionInfo))
        ? props.videoResolutionInfo
        : []);
    const streamUrl = currentVideoUrl || props.videoUrl || (player.currentSrc ? player.currentSrc() : '');

    try {
      const MenuButton = videojs.getComponent('MenuButton');
      const MenuItem = videojs.getComponent('MenuItem');

      let playlists = null;

      async function getLoadedPlaylists(p) {
        const src = p?.currentSrc ? p.currentSrc() : (p?.currentSource_ && p.currentSource_.src) || streamUrl;
        if (!src) return null;
        try {
          const reqHeaders = {};
          if (src.includes(".m3u8?id=")) {
            if (projectInfo?.projectConfig?.pubid) reqHeaders.pubid = projectInfo.projectConfig.pubid;
            if (projectInfo?.projectConfig?.channelid) reqHeaders.channelid = projectInfo.projectConfig.channelid;
            if (uid) reqHeaders.uid = uid;
            if (accessToken) reqHeaders["access-token"] = accessToken;
          }

          const response = await fetch(src, {
            method: 'GET',
            headers: reqHeaders
          });
          if (!response.ok) return null;
          const text = await response.text();

          const lines = text.split('\n');
          const list = [];
          let lastResolution = null;
          for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            if (line.startsWith('#EXT-X-STREAM-INF')) {
              const resMatch = line.match(/RESOLUTION=(\d+)x(\d+)/);
              if (resMatch) {
                lastResolution = { width: parseInt(resMatch[1], 10), height: parseInt(resMatch[2], 10) };
              } else {
                lastResolution = null;
              }
            } else if (line && !line.startsWith('#')) {
              if (lastResolution) {
                list.push({
                  attributes: { RESOLUTION: lastResolution },
                  uri: line
                });
                lastResolution = null;
              }
            }
          }
          return list;
        } catch (err) {
          console.error('Error fetching or parsing m3u8 playlist:', err);
          if (p?.tech_?.vhs?.playlists?.master?.playlists) {
            return p.tech_.vhs.playlists.master.playlists;
          }
          return null;
        }
      }

      function findPlaylistByType(list, type) {
        if (!list || !Array.isArray(list)) return null;
        const targetNum = parseInt(type, 10);
        for (let i = 0; i < list.length; i++) {
          const p = list[i];
          if (p.attributes && p.attributes.RESOLUTION) {
            const h = p.attributes.RESOLUTION.height;
            const w = p.attributes.RESOLUTION.width;
            const resString = h + 'p';
            if (resString.toLowerCase() === String(type).toLowerCase()) return p;
            if (targetNum === 1080 && (h >= 800 || w >= 1900)) return p;
            if (targetNum === 720 && ((h >= 500 && h < 800) || (w >= 1200 && w < 1900))) return p;
            if (targetNum === 480 && ((h >= 350 && h < 500) || (w >= 800 && w < 1200))) return p;
            if (targetNum === 360 && (h < 350 || w < 800)) return p;
          }
        }
        return null;
      }

      function switchToPlaylist(p, playlistItem, type) {
        if (!playlistItem) return;
        let baseUrl = '';
        const currentSrc = p?.currentSrc ? p.currentSrc() : streamUrl;
        if (currentSrc) {
          try {
            const urlObj = new URL(currentSrc, window.location.href);
            baseUrl = urlObj.origin + urlObj.pathname.substring(0, urlObj.pathname.lastIndexOf('/') + 1);
          } catch (e) {
            baseUrl = '';
          }
        }
        const playlistUri = playlistItem.uri;
        const query = (currentSrc && currentSrc.includes('?')) ? currentSrc.substring(currentSrc.indexOf('?')) : '';
        const urlWithToken = playlistUri.startsWith('http')
          ? playlistUri
          : (baseUrl + playlistUri + (playlistUri.includes('?') ? '' : query));
        const currentTime = p.currentTime();
        const wasPlaying = !p.paused();
        p.src({ src: urlWithToken, type: 'application/x-mpegURL' });
        p.one('loadedmetadata', function () {
          p.currentTime(currentTime);
          if (wasPlaying && currentTime > 0) p.play();
        });
        return urlWithToken;
      }

      const QualityMenuButton = videojs.extend(MenuButton, {
        constructor: function (p, btnOptions) {
          MenuButton.call(this, p, btnOptions);
          this.resolutions = (btnOptions && Array.isArray(btnOptions.videoResolutionInfo))
            ? btnOptions.videoResolutionInfo
            : resolutions;
          this.streamUrl = (btnOptions && btnOptions.streamUrl) || streamUrl;

          const storedRes = localStorage.getItem('videoSelectedResolution');
          const hasStored = storedRes && this.resolutions.some(r => String(r.type || r.name).toLowerCase() === String(storedRes).toLowerCase());
          this.currentQuality = hasStored ? storedRes : (this.resolutions[0]?.name || this.resolutions[0]?.type || 'Auto');
          this.updateButtonText();

          if (this.resolutions.length > 0) {
            this.show();
            this.removeClass('vjs-hidden');
          }

          if (hasStored && String(storedRes).toLowerCase() !== 'auto') {
            p.one('loadedmetadata', async function () {
              playlists = await getLoadedPlaylists(p);
              const found = findPlaylistByType(playlists, storedRes);
              if (found) {
                switchToPlaylist(p, found, storedRes);
                this.currentQuality = storedRes;
                this.updateButtonText();
              }
            }.bind(this));
          }

          p.on('loadedmetadata', async function () {
            if (!playlists) {
              playlists = await getLoadedPlaylists(p);
            }
          }.bind(this));
        },
        updateResolutions: function (newResolutions, newStreamUrl) {
          this.resolutions = (newResolutions && Array.isArray(newResolutions))
            ? newResolutions
            : [];
          if (newStreamUrl) this.streamUrl = newStreamUrl;
          playlists = null;

          const storedRes = localStorage.getItem('videoSelectedResolution');
          const hasStored = storedRes && this.resolutions.some(r => String(r.type || r.name).toLowerCase() === String(storedRes).toLowerCase());
          this.currentQuality = hasStored ? storedRes : (this.resolutions[0]?.name || this.resolutions[0]?.type || 'Auto');

          if (this.update) {
            this.update();
          }
          this.updateButtonText();

          if (this.resolutions.length > 0) {
            this.show();
            this.removeClass('vjs-hidden');
            if (this.el()) {
              this.el().style.display = 'inline-flex';
            }
          }
        },
        createItems: function () {
          const items = [];
          const self = this;
          const resList = (self.resolutions && Array.isArray(self.resolutions))
            ? self.resolutions
            : resolutions;

          resList.forEach(res => {
            const resType = res.type || res.name;
            const isSelected = String(self.currentQuality).toLowerCase() === String(resType).toLowerCase();
            const labelText = res.name ? capitalize(res.name) : String(resType).toUpperCase();
            const item = new MenuItem(player, {
              label: labelText,
              selectable: true,
              selected: isSelected
            });

            item.on('click', async function () {
              try {
                if (!playlists) {
                  playlists = await getLoadedPlaylists(player);
                }

                items.forEach(i => i.selected(false));
                item.selected(true);

                if (String(resType).toLowerCase() === 'auto') {
                  const masterUrl = self.streamUrl || streamUrl || res.url;
                  localStorage.setItem('videoSelectedResolution', 'Auto');
                  if (masterUrl) {
                    const currentTime = player.currentTime();
                    const wasPlaying = !player.paused();
                    player.src({ src: masterUrl, type: 'application/x-mpegURL' });
                    player.one('loadedmetadata', function () {
                      player.currentTime(currentTime);
                      if (wasPlaying && currentTime > 0) player.play();
                    });
                  }
                  self.currentQuality = 'Auto';
                  self.updateButtonText();
                  return;
                }

                const foundPlaylist = findPlaylistByType(playlists, resType);
                if (foundPlaylist) {
                  localStorage.setItem('videoSelectedResolution', resType);
                  switchToPlaylist(player, foundPlaylist, resType);
                  self.currentQuality = resType;
                  self.updateButtonText();
                } else if (res.url) {
                  localStorage.setItem('videoSelectedResolution', resType);
                  const currentTime = player.currentTime();
                  const wasPlaying = !player.paused();
                  player.src({ src: res.url, type: 'application/x-mpegURL' });
                  player.one('loadedmetadata', function () {
                    player.currentTime(currentTime);
                    if (wasPlaying && currentTime > 0) player.play();
                  });
                  self.currentQuality = resType;
                  self.updateButtonText();
                } else {
                  // Fallback: if master playlist has playlist.m3u8, try playlist~<type>.m3u8
                  const masterUrl = self.streamUrl || streamUrl;
                  if (masterUrl && masterUrl.includes('playlist.m3u8')) {
                    const fallbackUrl = masterUrl.replace('playlist.m3u8', `playlist~${resType}.m3u8`);
                    localStorage.setItem('videoSelectedResolution', resType);
                    const currentTime = player.currentTime();
                    const wasPlaying = !player.paused();
                    player.src({ src: fallbackUrl, type: 'application/x-mpegURL' });
                    player.one('loadedmetadata', function () {
                      player.currentTime(currentTime);
                      if (wasPlaying && currentTime > 0) player.play();
                    });
                    self.currentQuality = resType;
                    self.updateButtonText();
                  } else {
                    console.warn('Could not find matching loaded playlist for', resType);
                  }
                }
              } catch (err) {
                console.error('Error switching quality:', err);
              }
            });
            items.push(item);
          });

          return items;
        },
        updateButtonText: function () {
          const el = this.el();
          if (el) {
            let placeholder = el.querySelector('.vjs-icon-placeholder');
            if (placeholder) {
              placeholder.textContent = this.currentQuality || 'Auto';
            } else {
              const btn = el.querySelector('button') || el;
              let labelSpan = btn.querySelector('.vjs-quality-display');
              if (!labelSpan) {
                labelSpan = document.createElement('span');
                labelSpan.className = 'vjs-quality-display';
                btn.appendChild(labelSpan);
              }
              labelSpan.textContent = this.currentQuality || 'Auto';
            }
          }
        },
        handleClick: async function () {
          if (!playlists) {
            playlists = await getLoadedPlaylists(player);
            if (this.update) {
              this.update();
            }
          }
          MenuButton.prototype.handleClick.call(this);
          this.updateButtonText();
        }
      });

      videojs.registerComponent('QualityMenuButton', QualityMenuButton);

      const controlBar = player.getChild('controlBar') || player.controlBar;
      if (controlBar) {
        let existingBtn = controlBar.getChild('QualityMenuButton');
        if (existingBtn) {
          if (typeof existingBtn.updateResolutions === 'function') {
            existingBtn.updateResolutions(resolutions, streamUrl);
            return;
          } else {
            controlBar.removeChild(existingBtn);
            existingBtn.dispose && existingBtn.dispose();
            existingBtn = null;
          }
        }

        let insertIndex = undefined;
        const fs = controlBar.getChild('fullscreenToggle') || controlBar.getChild('FullscreenToggle') || controlBar.getChild('fullScreenToggle');
        if (fs && typeof controlBar.children === 'function') {
          const children = controlBar.children();
          const idx = children.indexOf(fs);
          if (idx >= 0) insertIndex = idx;
        }
        if (insertIndex === undefined && typeof controlBar.children === 'function') {
          insertIndex = Math.max(0, controlBar.children().length - 1);
        }

        controlBar.addChild('QualityMenuButton', {
          videoResolutionInfo: resolutions,
          streamUrl: streamUrl
        }, insertIndex);

        const qBtn = controlBar.getChild('QualityMenuButton');
        if (qBtn && qBtn.el()) {
          qBtn.el().classList.add('vjs-quality-menu-button', 'vjs-control');
          qBtn.el().setAttribute('aria-label', 'Video Quality');
          qBtn.show();
          qBtn.removeClass('vjs-hidden');
          qBtn.el().style.display = 'inline-flex';
          qBtn.updateButtonText();
        }
      }

      const disableQuality = () => {
        const cb = player.getChild('controlBar') || player.controlBar;
        const btn = cb?.getChild('QualityMenuButton');
        if (btn && btn.disable) btn.disable();
      };
      const enableQuality = () => {
        const cb = player.getChild('controlBar') || player.controlBar;
        const btn = cb?.getChild('QualityMenuButton');
        if (btn) {
          if (btn.enable) btn.enable();
          btn.show && btn.show();
          btn.removeClass && btn.removeClass('vjs-hidden');
          if (btn.el()) btn.el().style.display = 'inline-flex';
        }
      };

      player.on && player.on('adstart', disableQuality);
      player.on && player.on('adend', enableQuality);
      player.on && player.on('ads-ad-started', disableQuality);
      player.on && player.on('ads-ad-ended', enableQuality);
      player.on && player.on('ima3-started', disableQuality);
      player.on && player.on('ima3-complete', enableQuality);
      player.on && player.on('contentresume', enableQuality);

    } catch (e) {
      console.warn('createQualityButton error', e);
    }
  }

  useEffect(() => {
    if (playerRef.current && !is_live) {
      createQualityButton(playerRef.current, videoResolutionInfo, videoUrl);
    }
  }, [videoResolutionInfo, videoUrl, is_live]);

  useEffect(() => {
    let clear = true
    if (props?.liveData) {
      createSSAI("", "", "", clear)

    }
    return () => {
      createSSAI("", "", "", clear)
    }
  }, [props?.liveData])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    console.log('typeof player.ima', props);

    try {
      if (props?.adUrl) {
        var imaOptions = {
          adTagUrl: props?.adUrl
        };

        try {
          player.ima(imaOptions)
        } catch (error) {
          console.log('ima error', error);

        }

        player.on('error', () => {
          const error = player.error(); // Get the error details
          if (error) {
            console.log("Video.js Error: ", error);

            // Example: Logging specific error codes
            console.log(`Error Code: ${error.code} - ${error.message || "No message provided"}`);

            if (error.code === 4) {
              console.log("MEDIA_ERR_SRC_NOT_SUPPORTED: The video source is unsupported.");
            }
          }
        });

        // Pause the video when ad starts
        player.on('ads-ad-started', () => {
          const videoElement = videoRef.current;
          // console.log('ads-ad-started', videoElement);

          try {
            // console.log('Before pause:', player.paused());  // Log current state
            document.getElementById('vjs_video_player_html5_api').pause()
            // console.log('After pause:', player.paused());  // Log state after pause
          } catch (error) {
            console.log('error', error);

          }




          // videoElement.pause();
        });

        player.on('play', () => {
          const posterImage = player.el().querySelector('.vjs-poster');
          if (posterImage && isRadioLive) {
            // posterImage.style.display = 'block'; // Keep the poster visible
          }
        });

        // Resume the video when ad ends
        player.on('ads-ad-ended', () => {
          // console.log('ads-ad-ended');

          player.play();
        });

        player.on('ima3-started', () => {
          // console.log('ima3 Ad started');
          player.pause(); // Pause video when ad starts
        });

        player.on('ima3-complete', () => {
          // console.log('ima3 Ad completed');
          player.play(); // Resume video when ad ends
        });

      }
    } catch (error) {
      console.log('ima error', error);

    }

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;

      }
    };


  }, [videoRef]);

  useEffect(() => {
    setControlColor(projectInfo?.projectConfig?.config?.BUTTON_COLOR || '#fff');
  }, [projectInfo]);

  function createSSAI(url, videoElem, adsParams, clearFlag) {


    let eachSecondInterval;
    let refreshInterval;
    if (clearFlag === false) {

      sessionCreation(url);

      var arr = url.split("/");
      var result = arr[0] + "//" + arr[2]
      var domainOfUrl = result;



      var previousTime = 0;
      var beaconTime = [];
      var trackingUrl = domainOfUrl;
      var beaconData = []
      var whereYouAt = 0;
      eachSecondInterval = setInterval(eachSecond, 1000);




      function isInArray(value, array) {
        return array.indexOf(value);
      }


      function eachSecond() {


        whereYouAt = whereYouAt + 1;
        whereYouAt = Math.round(whereYouAt)



        if (whereYouAt != previousTime) {
          previousTime = whereYouAt;

          if (beaconTime.length > 0) {

            if (isInArray(whereYouAt, beaconTime) > -1) {

              var temp = beaconData[isInArray(whereYouAt, beaconTime)].beaconUrls;
              for (var i = 0; i < temp.length; i++) {

                callAdTrackingUrl(temp[i])
              }



            }



          }

        }
      }


      function callAPI(url) {

        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
          if (request.readyState == 4 && request.status == 200) {


            var trackingData = JSON.parse(request.responseText);

            var avails = trackingData.avails;



            for (let k = 0; k < avails.length; k++) {


              var avail = avails[k];

              var ads = avail.ads;


              for (let j = 0; j < ads.length; j++) {

                var trackingEvents = ads[j].trackingEvents;

                for (k = 0; k < trackingEvents.length; k++) {

                  var trackingEvent = trackingEvents[k]



                  if (trackingEvent && trackingEvent.eventType) {
                    var eventType = trackingEvent.eventType;
                    if (eventType == "start" || eventType == "firstQuartile" || eventType == "firstQuartile" || eventType == "midpoint" || eventType == "impression") {
                      beaconTime.push(Math.round(trackingEvent.startTimeInSeconds))
                      beaconData.push(trackingEvent)


                    }
                  }

                }



              }




            }


          } else if (request.status == 502) {

            beaconTime = [];

          }

        }
        request.open("GET", url);
        request.send(null);
      }

      function sessionCreation(theUrl) {

        var data = JSON.stringify(adsParams);

        var xhr = new XMLHttpRequest();


        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            var jsonResult = JSON.parse(this.responseText)


            // const player = videojs(videoElem);

            const player = playerRef.current = videojs(videoElem, options, () => {
              applyCaptionFontSize(player);
              onReady && onReady(player);
            });
            try {
              if (!is_live) {
                createRestartButton && createRestartButton(player);
                createQualityButton && createQualityButton(player);
              }
            } catch (e) {
              console.warn('Control button init failed (SSAI)', e);
            }

            if (jsonResult) {
              player.src({
                src: domainOfUrl + jsonResult.manifestUrl,
                type: 'application/x-mpegURL',
              });
              trackingUrl = trackingUrl + jsonResult.trackingUrl;
              refreshInterval = setInterval(refresh, 10000);
            }




          }
        });

        xhr.open("POST", theUrl);
        xhr.setRequestHeader("content-type", "application/json");


        xhr.send(data);


      }

      function refresh() {
        callAPI(trackingUrl);
      }



      function callAdTrackingUrl(theUrl) {


        var i = document.createElement("img");
        i.src = theUrl;



      }
    } else if (clearFlag === true) {
      clearTimeout(eachSecondInterval)
      clearTimeout(refreshInterval)
    }




  }
  return (
    <div data-vjs-player style={{position: 'relative'}}>
      <style>{`
        .video-js .vjs-poster {
          background-size: contain !important;
          background-position: center center !important;
          background-repeat: no-repeat !important;
          background-color: #000000 !important;
        }
        .video-js .vjs-poster img,
        .video-js video,
        .video-js .vjs-tech {
          object-fit: contain !important;
          object-position: center !important;
          background-color: #000000 !important;
        }
        ::cue,
        video::cue {
          font-size: 15px;
          line-height: 1.3 !important;
        }
        .video-js .vjs-text-track-display {
          font-size: 15px;
        }
        .video-js .vjs-text-track-cue,
        .vjs-text-track-cue {
          font-size: 15px;
          line-height: 1.3 !important;
        }
        .video-js .vjs-text-track-cue > div,
        .vjs-text-track-cue > div {
          font-size: inherit;
          line-height: 1.3 !important;
          padding: 2px 6px !important;
        }
        @media (max-width: 768px) {
          ::cue,
          video::cue,
          .video-js .vjs-text-track-display,
          .video-js .vjs-text-track-cue {
            font-size: 13px;
          }
          .video-js .vjs-text-track-cue > div,
          .vjs-text-track-cue > div {
            font-size: inherit;
          }
        }
        .video-js .vjs-menu-button-popup .vjs-menu {
          bottom: 100% !important;
          margin-bottom: 0 !important;
          padding-bottom: 10px !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu:before {
          content: '' !important;
          position: absolute !important;
          left: -20px !important;
          right: -20px !important;
          bottom: -20px !important;
          height: 30px !important;
          background: transparent !important;
          z-index: 1 !important;
        }
        .video-js .vjs-menu-button-popup:hover .vjs-menu,
        .video-js .vjs-menu-button-popup.vjs-hover .vjs-menu,
        .video-js .vjs-menu-button-popup.vjs-menu-button-opened .vjs-menu,
        .video-js .vjs-menu-button-popup .vjs-menu.vjs-lock-showing,
        .video-js .vjs-menu-button-popup .vjs-menu:hover {
          display: block !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
          background-color: rgba(0, 0, 0, 0.9) !important;
          border-radius: 6px !important;
          padding: 6px 0 !important;
          bottom: 0 !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item {
          padding: 8px 16px !important;
          font-size: 14px !important;
          text-transform: capitalize !important;
          cursor: pointer !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item:hover,
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected {
          background-color: rgba(255, 255, 255, 0.2) !important;
          color: #ffffff !important;
        }
        .video-js .vjs-quality-menu-button.vjs-hidden {
          display: none !important;
        }
        .video-js .vjs-quality-menu-button {
          width: 4.5em !important;
          cursor: pointer !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .video-js .vjs-quality-menu-button .vjs-icon-placeholder,
        .video-js .vjs-quality-menu-button .vjs-quality-display {
          font-family: inherit !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          text-transform: uppercase !important;
          line-height: normal !important;
          letter-spacing: 0.5px !important;
          width: 100% !important;
          height: 100% !important;
        }
        .video-js .vjs-quality-menu-button .vjs-icon-placeholder:before {
          content: '' !important;
        }
        .video-js .vjs-quality-menu-button:hover .vjs-icon-placeholder,
        .video-js .vjs-quality-menu-button:focus .vjs-icon-placeholder,
        .video-js .vjs-quality-menu-button:hover .vjs-quality-display,
        .video-js .vjs-quality-menu-button:focus .vjs-quality-display {
          color: ${controlColor} !important;
        }
        .video-js .vjs-menu-item-text {
          text-transform: uppercase !important;
          font-size: 13px !important;
        }
        .video-js .vjs-play-progress {
          background-color: ${controlColor};
        }
        .videojs-watermark {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 1000;
          pointer-events: none;
          max-width: 120px;
          max-height: 60px;
        }
       
        .video-js.vjs-fullscreen ~ .videojs-watermark,
        .vjs-fullscreen .videojs-watermark {
          position: fixed !important;
          top: 20px !important;
          right: 20px !important;
        }
        .vjs-control:hover {
          color: ${controlColor}; 
        }
        .vjs-volume-level {
          background-color: ${controlColor} !important;
        }
        .vjs-control:hover > .vjs-icon-placeholder,
        .vjs-control:hover > .vjs-icon-play,
        .vjs-control:hover > .vjs-icon-pause,
        .vjs-control:hover > .vjs-icon-volume-high,
        .vjs-control:hover > .vjs-icon-captions,
        .vjs-control:hover > .vjs-icon-fullscreen-enter,
        .vjs-control:hover > .vjs-icon-fullscreen-exit {
          background: transparent !important; 
          color: ${controlColor} !important; 
        }
        .vjs-restart-button {
          color: rgba(255,255,255,0.85);
          padding: 0 8px;
          font-size: 13px;
          display: inline-flex;
          align-items: center;
        }
        .vjs-restart-button .vjs-restart-svg {
          width: 18px;
          height: 18px;
          fill: rgba(255,255,255,0.85);
          vertical-align: middle;
        }
        .vjs-restart-button:hover,
        .vjs-restart-button:focus {
          color: ${controlColor};
        }
        .vjs-restart-button:hover .vjs-restart-svg,
        .vjs-restart-button:focus .vjs-restart-svg {
          fill: ${controlColor};
        }
        .vjs-restart-button .vjs-control-text {
          position: absolute;
          left: -9999px;
          width: 1px;
          height: 1px;
          overflow: hidden;
        }
      `}</style>
   
      {props?.watermark && (
        <img
          src={props?.watermark}
          alt="Watermark"
          className="videojs-watermark"
          aria-hidden="true"
        />
      )}
      <video ref={videoRef} id='vjs_video_player' className='video-js vjs-big-play-centered' poster={poster} muted={options?.muted} playsInline>
        {
          props?.closedCaptions?.map((item, index) => (
            <track key={index} kind='captions' src={item?.closed_caption_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }
        {
          props?.subtitles?.map((item, index) => (
            <track key={index} kind='captions' src={item?.subtitle_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }
      </video>
    </div>
  );
}

export default VideoJS;
